import React from "react";
import moment from "moment";
import DatePicker from "Components/common/DatePicker/DatePicker";

class RegistrationDate extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <DatePicker
                onChange={this.props.onChange}
                required={true}
                popperClass="registrationDate"
                classes="form-control no-border"
                selected={this.props.selected ? moment(this.props.selected) : null}
            />
        );
    }
}

export default RegistrationDate;